import { storefrontAiTr } from './storefront.ai.tr';
import { storefrontNeedsTr } from './storefront.needs.tr';
/** Vitrin arayüz metinleri (tr). Vitrinin istemci paketi yalnızca bunu ve ortak/hata metinlerini yükler (F7-17). */
export const storefrontTr = {
  google: {
    or: 'veya',
    continue: 'Google ile devam et',
    signUpTitle: 'Google ile üye ol',
    newAccount: '{{email}} Google hesabıyla yeni üyelik açılacak.',
    name: 'Ad: {{name}}',
    noPassword:
      'Hesabınız şifresiz açılır; dilediğinizde Hesabım → Bağlı hesaplar bölümünden şifre belirleyebilirsiniz.',
    createAccount: 'Hesabı oluştur',
    linkedTitle: 'Bağlı hesaplar',
    linked: 'Google: {{email}}',
    setPasswordFirst:
      'Google bağlantısını kaldırmadan önce bir şifre belirleyin; yoksa hesabınıza giremezsiniz.',
    newPassword: 'Yeni şifre',
    setPassword: 'Şifre belirle',
    passwordSet: 'Şifreniz belirlendi.',
    unlink: 'Google bağlantısını kaldır',
    unlinkConfirm: 'Google bağlantısı kaldırılsın mı? Sonra e-posta ve şifrenizle girersiniz.',
    unlinked: 'Google bağlantısı kaldırıldı.',
    reauth: 'Google ile yeniden giriş yap',
  },
  ai: storefrontAiTr,
  needsFinder: storefrontNeedsTr,
  brands: 'Markalar',
  suggest: {
    label: 'Arama önerileri',
    groups: { products: 'Ürünler', categories: 'Kategoriler', brands: 'Markalar', all: 'Tüm sonuçlar' },
    all: '"{{q}}" için tüm sonuçlar ({{count}})',
    status: '{{count}} öneri. Seçmek için aşağı ok tuşunu kullanın.',
    none: 'Öneri yok. Enter ile arayabilirsiniz.',
  },
  quick: {
    view: 'Hızlı bak: {{title}}',
    viewShort: 'Hızlı bak',
    add: 'Sepete ekle: {{title}}',
    addShort: 'Sepete ekle',
    title: 'Hızlı bakış',
    close: 'Kapat',
    details: 'Ürün sayfasına git',
    loading: 'Yükleniyor…',
    failed: 'Ürün bilgisi alınamadı. Ürün sayfasını açın.',
  },
  filters: {
    open: 'Süzgeçler',
    title: 'Süzgeçler',
    close: 'Kapat',
    form: 'Ürün süzgeçleri',
    brand: 'Marka',
    price: 'Fiyat ({{currency}})',
    priceMin: 'En az',
    priceMax: 'En çok',
    stock: 'Stok durumu',
    inStockOnly: 'Yalnızca stoktakiler',
    discount: 'İndirim',
    discountedOnly: 'İndirimli ürünler',
    active: 'Seçili süzgeçler',
    remove: 'Süzgeci kaldır: {{name}}',
    clearAll: 'Tümünü temizle',
    below: '{{max}} altı',
    above: '{{min}} ve üzeri',
    range: '{{min}} – {{max}}',
    priceChip: 'Fiyat: {{range}}',
    option: '{{label}} ({{count}})',
  },
  preparingTitle: 'Yeni mağazamız hazırlanıyor',
  preparingLead: 'Sitemiz şu anda yapım aşamasında. Siparişler açıldığında bu adreste olacağız.',
  brandsLabel: 'Markalarımız',
  contactLater: 'İletişim ve satıcı bilgileri yayına geçmeden önce bu sayfada yer alacak.',
  unknownDomainTitle: 'Bu adreste henüz bir mağaza yok',
  unknownDomainLead:
    'Alan adı sunucuya ulaşıyor ancak panelde bir mağazaya bağlanmamış. Yönetim panelinde Mağazalar > Alan adı ekle adımını tamamlayın.',
  unavailableTitle: 'Mağaza şu anda yanıt vermiyor',
  unavailableLead: 'Kısa bir bakım veya bağlantı sorunu olabilir. Birkaç dakika sonra yeniden deneyin.',
  notFoundTitle: 'Aradığınız sayfa bulunamadı',
  notFoundLead:
    'Adres değişmiş ya da sayfa kaldırılmış olabilir. Ürünlerde arayabilir veya aşağıdaki bağlantılardan devam edebilirsiniz.',
  notFoundSearch: 'Ürünlerde ara',
  notFoundHome: 'Ana sayfa',
  goneTitle: 'Bu sayfa kaldırıldı',
  goneLead: 'Aradığınız sayfa kalıcı olarak kaldırıldı.',
  maintenanceTitle: 'Kısa bir bakımdayız',
  maintenanceLead: 'Mağaza birazdan yeniden açılacak.',
  acceptMembership:
    'Üyelik koşullarını ve kişisel verilerin işlenmesine ilişkin aydınlatma metnini okudum, kabul ediyorum.',
  acceptSalesTerms: 'Ön bilgilendirme formunu ve mesafeli satış sözleşmesini okudum, onaylıyorum.',
  activateTitle: 'Hesabınızı etkinleştirin',
  activateLead: 'Merhaba {{name}}, hesabınız mağaza tarafından oluşturuldu. Şifrenizi belirleyin.',
  resetLead: 'Merhaba {{name}}, yeni şifrenizi belirleyin.',
  addToCart: 'Sepete ekle',
  buyNow: 'Hemen satın al',
  added: 'Sepete eklendi.',
  all: 'Tümü',
  allProducts: 'Tüm ürünler',
  pageTitleNumbered: '{{title}} – Sayfa {{page}}',
  allSpecies: 'Tümü',
  applicationPending: 'Bayilik başvurunuz değerlendiriliyor.',
  applicationReceived:
    'Başvurunuz alındı. Sonucu e-postayla bildireceğiz; durumunu Hesabım sayfasından da izleyebilirsiniz.',
  applicationRejected: 'Önceki başvurunuz onaylanmadı.',
  apply: 'Uygula',
  applyCoupon: 'Uygula',
  applyDealer: 'Bayilik başvurusu',
  applyLead:
    'Veteriner kliniği, pet shop veya eczane iseniz bayi olarak başvurabilirsiniz. Başvurunuz onaylandığında giriş yaptığınızda bayi fiyatlarını görürsünüz.',
  applySignInFirst: 'Başvuru için önce giriş yapın veya üye olun.',
  awaitingPaymentNote: 'Siparişiniz ödeme bekliyor.',
  breadcrumb: 'Konum',
  cart: 'Sepet',
  cartEmpty: 'Sepetiniz boş.',
  cartWithCount: 'Sepet, {{count}} ürün',
  speciesProperty: 'Hedef tür',
  speciesNames: {
    cat: 'Kedi',
    dog: 'Köpek',
    bird: 'Kuş',
    rodent: 'Kemirgen',
    rabbit: 'Tavşan',
    reptile: 'Sürüngen ve kaplumbağa',
    exotic: 'Diğer egzotik',
  },
  categories: 'Kategoriler',
  changePassword: 'Şifreyi değiştir',
  checkout: 'Siparişi tamamla',
  chooseOption: 'Bir seçenek seçin.',
  consents: 'Kampanya iletileri',
  privacy: {
    title: 'Kişisel verilerim',
    lead: 'Kişisel verilerinizle ilgili haklarınızı (KVKK m.11) buradan kullanabilirsiniz. Ayrıntı:',
    noticeLink: 'Aydınlatma metni',
    exportTitle: 'Verilerimi indir',
    exportLead:
      'Hesabınız, adresleriniz, siparişleriniz, izinleriniz ve diğer kayıtlarınızın bir kopyası JSON dosyası olarak hemen iner.',
    password: 'Şifreniz',
    export: 'Verilerimi indir',
    exported: 'Verileriniz indirildi.',
    erasureTitle: 'Hesabımı sil',
    erasureLead:
      'Silme başvurunuz en geç 30 gün içinde sonuçlandırılır ve e-postayla bildirilir. Hesabınız kapanır; adresleriniz, favorileriniz ve iletişim bilgileriniz silinir. Vergi mevzuatı gereği sipariş ve fatura kayıtları yasal süre boyunca saklanır. Açık siparişiniz varsa teslim edildikten sonra sonuçlanır.',
    reason: 'Açıklama (isteğe bağlı)',
    understood: 'Hesabımın kapatılacağını ve bu işlemin geri alınamayacağını anlıyorum.',
    requestErasure: 'Silme başvurusu gönder',
    erasureSent: 'Silme başvurunuz alındı. Sonucu e-postayla bildireceğiz.',
    erasureOpen: 'Açık bir silme başvurunuz var; sonuçlandığında e-postayla bildirilecek.',
    myRequests: 'Başvurularım',
    dueBy: 'en geç {{date}}',
    kinds: {
      export: 'Verilerin kopyası',
      erasure: 'Silme',
      info: 'Bilgi talebi',
      rectification: 'Düzeltme',
      objection: 'İtiraz',
      other: 'Diğer',
    },
    statuses: {
      received: 'Alındı',
      in_progress: 'İnceleniyor',
      completed: 'Sonuçlandı',
      rejected: 'Kabul edilmedi',
    },
  },
  consentsNote: 'Sipariş ve kargo bilgilendirmeleri bu izinlerden bağımsız olarak gönderilir.',
  coupon: 'Kupon kodu',
  createAccount: 'Üye ol',
  currentPassword: 'Mevcut şifre',
  dealerBar: 'Bayi fiyatları gösteriliyor ({{company}}).',
  dealerOf: '{{company}} adına bayi hesabıyla giriş yaptınız; bayi fiyatlarını görüyorsunuz.',
  dealerPrice: 'Bayi fiyatı',
  dealership: 'Bayilik',
  discount: 'İndirim ({{code}})',
  documents: 'Belgeler (vergi levhası vb.)',
  documentsHint: 'PDF, JPEG veya PNG; en fazla 10 MB. Belgeleri yalnızca mağaza yetkilileri görür.',
  email: 'E-posta',
  emailNotVerified: 'e-posta doğrulanmadı',
  emailVerified: 'E-posta adresiniz doğrulandı.',
  feedRegistration: 'Yem kayıt numarası: {{no}}',
  feedRegistrationProperty: 'Yem kayıt numarası',
  countryRegistration: 'Kayıt / izin numarası ({{country}}): {{no}}',
  notInCountry:
    'Bu ürün seçtiğiniz ülkede satışta değil. Üst çubuktaki ülke seçiminden başka bir ülkeyi seçebilirsiniz.',
  itemNotInCountry: 'Bu ürün seçtiğiniz ülkede satışta değil; sepetten çıkarın veya ülkeyi değiştirin.',
  marketLabel: 'Ülke ve para birimi',
  languageLabel: 'Dil',
  marketOption: '{{name}} ({{currency}})',
  forSpecies: 'Uygun olduğu türler: {{list}}',
  forgot: 'Şifremi unuttum',
  forgotTitle: 'Şifremi unuttum',
  from: 'başlayan',
  fullName: 'Ad soyad',
  goToCart: 'Sepete git',
  homeLead: 'Kedi ve köpekler için takviyeler.',
  itemInsufficient: 'Stokta yalnızca {{count}} adet var.',
  itemUnavailable: 'Bu ürün artık satışta değil; sepetten çıkarın.',
  leaflet: 'Ürün bilgileri',
  loading: 'Yükleniyor…',
  lowStock: 'Son {{count}} adet',
  lowest30: 'Son 30 günün en düşük fiyatı: {{price}}',
  discountPercent: '%{{n}} indirim',
  marketingEmail: 'Kampanya ve yenilikler için e-posta almak istiyorum.',
  marketingLegend: 'İsteğe bağlı ileti izinleri',
  marketingSms: 'Kampanya ve yenilikler için SMS almak istiyorum.',
  menu: 'Menü',
  mainMenu: 'Ana menü',
  faq: 'Sık sorulan sorular',
  pagePreviewNotice:
    'Sayfa önizlemesi: yayımlanmamış taslağı görüyorsunuz. Bu bağlantı yalnızca size özeldir.',
  menuSeeAll: 'Tümü: {{label}}',
  homeCrumb: 'Ana sayfa',
  qaTitle: 'Soru ve cevaplar',
  reviews: {
    title: 'Değerlendirmeler',
    empty:
      'Bu ürün için henüz değerlendirme yok. Ürünü satın alıp teslim alan müşteriler değerlendirme yazabilir.',
    count: '{{count}} değerlendirme',
    outOf: '5 üzerinden {{value}} puan',
    stars: '{{n}} yıldız',
    distribution: 'Puan dağılımı',
    verified: 'Doğrulanmış alışveriş',
    storeReply: '{{store}} yanıtı',
    by: '{{name}}',
    sort: 'Sırala',
    sorts: { newest: 'En yeni', rating_desc: 'En yüksek puan', rating_asc: 'En düşük puan' },
    more: 'Daha fazla değerlendirme göster',
    write: 'Değerlendirme yazın',
    signIn: 'Değerlendirme yazmak için giriş yapın',
    notPurchased: 'Bu ürünü bu mağazadan satın alıp teslim aldıktan sonra değerlendirebilirsiniz.',
    alreadyReviewed: 'Bu ürünü değerlendirdiniz, teşekkür ederiz.',
    rating: 'Puanınız',
    ratingNames: { 1: 'Çok kötü', 2: 'Kötü', 3: 'Orta', 4: 'İyi', 5: 'Çok iyi' },
    reviewTitle: 'Başlık',
    optional: 'isteğe bağlı',
    body: 'Değerlendirmeniz',
    bodyHint:
      'En az 20 karakter. Ürünü nasıl kullandığınızı anlatın; kişisel bilgi, sağlık iddiası veya hastalık adı yazmayın. Değerlendirmeniz onaylandıktan sonra adınız ve soyadınızın baş harfiyle yayımlanır.',
    submit: 'Değerlendirmeyi gönder',
    sent: 'Değerlendirmeniz alındı. Onaylandıktan sonra ürün sayfasında yayımlanır.',
  },
  qaEmpty: 'Bu ürün hakkında henüz yanıtlanmış soru yok.',
  qaAsk: 'Soru sorun',
  qaLabel: 'Sorunuz',
  qaHint:
    'Sorunuz incelendikten sonra yanıtıyla birlikte bu sayfada yayımlanır; adınızın yalnızca baş harfli kısa hâli görünür. Telefon, adres gibi kişisel bilgi yazmayın.',
  qaSubmit: 'Soruyu gönder',
  qaSentNotify: 'Sorunuz alındı. Yanıtlandığında e-postayla haber vereceğiz.',
  qaSent: 'Sorunuz alındı. Yanıtlandığında bu sayfada yayımlanır.',
  qaSignIn: 'Soru sormak için giriş yapın',
  qaAsked: '{{name}} sordu',
  qaAnswered: '{{store}} yanıtladı',
  compare: 'Karşılaştır',
  compareTitle: 'Ürün karşılaştırma',
  compareAdd: 'Karşılaştırmaya ekle',
  compareRemove: 'Karşılaştırmadan çıkar',
  compareFull: 'En fazla 4 ürün karşılaştırılabilir.',
  compareBar: '{{count}} ürün karşılaştırmada',
  compareClear: 'Listeyi temizle',
  compareEmpty:
    'Karşılaştırmak için ürün sayfalarındaki "Karşılaştırmaya ekle" düğmesini kullanın (en fazla 4 ürün).',
  compareShare: 'Bu sayfanın adresini paylaşarak karşılaştırmayı başkalarına gönderebilirsiniz.',
  compareMissing: '{{count}} ürün artık satışta değil; tabloda gösterilmiyor.',
  compareTable: 'Seçilen ürünlerin özellikleri',
  compareRemoveOne: 'Kaldır: {{title}}',
  compareScroll: 'Karşılaştırma tablosu (yatay kaydırılabilir)',
  compareRows: {
    product: 'Ürün',
    price: 'Fiyat',
    unitPrice: 'Birim fiyat',
    net: 'Net miktar',
    species: 'Uygun olduğu türler',
    composition: 'İçerik (bileşim)',
    usage: 'Kullanım',
  },
  netUnits: { g: '{{n}} g', ml: '{{n}} ml', piece: '{{n}} adet' },
  notSpecified: 'Belirtilmemiş',
  favoriteAdd: 'Favorilere ekle',
  favoriteRemove: 'Favorilerden çıkar',
  favoriteLogin: 'Favorilere eklemek için giriş yapın',
  favoriteError: 'İşlem tamamlanamadı; tekrar deneyin.',
  favorites: 'Favorilerim',
  favoritesEmpty: 'Henüz favori ürününüz yok. Ürün kartlarındaki kalp düğmesiyle ekleyebilirsiniz.',
  favoritesHidden: '{{count}} favori ürün şu anda satışta değil; satışa dönünce burada yeniden görünür.',
  favoritesCount: '{{count}} ürün',
  favoritesSignIn: 'Favorilerinizi görmek için giriş yapın.',
  relatedProducts: 'Benzer ürünler',
  galleryLabel: 'Ürün görselleri',
  galleryShow: '{{n}}. görseli göster',
  galleryZoom: 'Görseli büyüt',
  galleryClose: 'Kapat',
  galleryPrev: 'Önceki görsel',
  galleryNext: 'Sonraki görsel',
  galleryPosition: '{{n}} / {{total}}',
  complementaryProducts: 'Birlikte iyi gider',
  share: 'Paylaş',
  shareCopied: 'Bağlantı kopyalandı.',
  shareFailed: 'Bağlantı kopyalanamadı; adres çubuğundan kopyalayın.',
  gtin: 'Barkod (GTIN): {{gtin}}',
  installments: 'Kredi kartına {{n}} taksite kadar (kart ve bankaya göre değişir)',
  returnInfo: {
    title: 'İade',
    days: 'Teslimden itibaren {{days}} gün içinde iade edebilirsiniz.',
    by_mail: 'İade kargoyla yapılır.',
    in_store: 'İade mağazada yapılır.',
    by_mail_or_in_store: 'İade kargoyla veya mağazada yapılır.',
    free: 'İade kargosu ücretsizdir.',
    customer_pays: 'İade kargo ücreti alıcıya aittir.',
    link: 'İade ve cayma koşulları (istisnalar dahil)',
  },
  shippingInfo: {
    title: 'Kargo ve teslimat',
    free: 'Ücretsiz',
    price: 'Kargo ücreti: {{price}}',
    freeOver: '{{price}} ve üzeri siparişte ücretsiz',
    delivery: 'Tahmini teslimat: {{range}}',
    days: 'Teslim süresi: {{days}}',
    cod: 'Kapıda ödeme yapılabilir',
    note: 'Teslim tarihi tahminidir; bayramlarda uzayabilir. Kesin kargo ücreti sepette hesaplanır.',
  },
  tableOfContents: 'İçindekiler',
  videos: {
    play: 'Videoyu oynat: {{title}}',
    notice: 'Video {{provider}} üzerinden yüklenir; oynattığınızda {{provider}} çerez kullanabilir.',
    providers: { youtube: 'YouTube', vimeo: 'Vimeo' },
  },
  documentKinds: {
    analysis_certificate: 'Analiz sertifikası',
    leaflet: 'Kullanma kılavuzu',
    safety_data_sheet: 'Güvenlik bilgi formu',
    registration: 'Kayıt / onay belgesi',
    other: 'Belge',
  },
  documentSize: 'PDF, {{size}}',
  subcategories: 'Alt kategoriler',
  relatedCategories: 'İlgili kategoriler',
  productCategories: 'Bu ürünün kategorileri',
  seoFallback: {
    home: '{{store}}: {{categories}}. Ürün içerikleri, kullanım bilgileri, makaleler ve satış noktaları.',
    homeNoCategories:
      '{{store}} çevrimiçi mağazası: ürün içerikleri, kullanım bilgileri, makaleler ve satış noktaları.',
    products:
      '{{store}} ürünlerinin tamamı: türe, kategoriye, markaya ve fiyata göre süzün; içerik ve kullanım bilgilerini inceleyin.',
    category:
      '{{name}} — {{store}}. Bu kategorideki ürünlerin içeriklerini, kullanım bilgilerini ve güncel fiyatlarını inceleyin.',
    brand: '{{name}} markasının tüm ürünleri: içerik, kullanım bilgisi ve güncel fiyatlar.',
    brands: '{{store}} vitrinindeki markalar ve her markanın ürünleri.',
    blog: '{{store}} makaleleri: evcil hayvanların bakımı ve beslenmesi üzerine yazılar.',
    contact: '{{store}} ile iletişim: iletişim formu ve satıcı bilgileri.',
    legal: '{{store}} {{title}}: metnin güncel ve yürürlükteki sürümü.',
    bankAccounts: '{{store}} banka hesapları: havale ve EFT ile ödeme için hesap ve IBAN bilgileri.',
  },
  llms: {
    categories: 'Kategoriler',
    pages: 'Sayfalar',
    legal: 'Yasal metinler',
    products: 'Tüm ürünler',
    articles: 'Makaleler',
    salesPoints: 'Satış noktaları',
    contact: 'İletişim',
    sitemap: 'Site haritası',
    productList: 'Ürünler',
    articleList: 'Son makaleler',
  },
  blog: 'Makaleler',
  blogEmpty: 'Henüz yazı yayımlanmadı.',
  blogAll: 'Tümü',
  blogCategories: 'Makale kategorileri',
  blogPages: 'Blog sayfaları',
  blogArchive: 'Arşiv',
  blogArchiveTitle: 'Makale arşivi: {{period}}',
  blogArchiveCount: '{{count}} yazı',
  blogArchiveYear: '{{year}} yılının yazıları',
  readingTime: '{{n}} dk okuma',
  publishedOn: 'Yayın: {{date}}',
  updatedOn: 'Güncelleme: {{date}}',
  byAuthor: 'Yazar: {{name}}',
  postReferences: 'Kaynaklar',
  postProducts: 'Yazıda geçen ürünler',
  postTags: 'Etiketler',
  postHealthNotice:
    'Bu yazı bilgilendirme amaçlıdır; muayene, tanı ve tedavinin yerine geçmez. Hayvanınızın sağlığıyla ilgili kararlar için veteriner hekiminize danışın.',
  postPreviewNotice:
    'Yazı önizlemesi: yayımlanmamış taslağı görüyorsunuz. Bu bağlantı yalnızca size özeldir.',
  allPosts: 'Tüm yazılar',
  sliderLabel: 'Öne çıkanlar',
  bannerGridLabel: 'Kampanyalar',
  sliderRole: 'slayt gösterisi',
  slideRole: 'slayt',
  slidePosition: '{{n}} / {{total}}',
  slidePrev: 'Önceki slayt',
  slideNext: 'Sonraki slayt',
  slideGoTo: '{{n}}. slayta git',
  sliderPause: 'Kaydırmayı durdur',
  sliderPlay: 'Kaydırmayı başlat',
  announcement: 'Duyuru',
  popupClose: 'Kapat',
  opensInNewTab: '(yeni sekmede açılır)',
  links: 'Bağlantılar',
  myAccount: 'Hesabım',
  myOrders: 'Siparişlerim',
  newPassword: 'Yeni şifre',
  newest: 'Yeni ürünler',
  next: 'Sonraki',
  prev: 'Önceki',
  noOrders: 'Henüz siparişiniz yok.',
  noPrice: 'Bu ürün şu an satışta değil.',
  noProducts: 'Bu bölümde henüz ürün yok.',
  noResults: 'Aramanıza uygun ürün bulunamadı.',
  offlinePaymentNote:
    'Online ödeme henüz yok: siparişiniz "Ödeme bekliyor" olarak alınır ve mağaza ödeme için sizinle iletişime geçer.',
  orderNo: 'Sipariş no',
  orderNote: 'Sipariş notu (isteğe bağlı)',
  orderPlaced: 'Siparişiniz alındı: {{number}}',
  orderPlacedLead: 'Ödeme ve teslimat için mağaza sizinle iletişime geçecek.',
  orderTitle: 'Sipariş {{number}}',
  outOfStock: 'Stokta yok',
  pageOf: 'Sayfa {{page}} / {{pages}}',
  pages: 'Sayfalar',
  password: 'Şifre',
  passwordChanged: 'Şifreniz değişti; diğer cihazlardaki oturumlar kapatıldı.',
  passwordHint: 'En az 12 karakter; tahmin edilmesi zor bir cümle seçin.',
  birthdayOptional: 'Doğum günü (isteğe bağlı)',
  birthdayMonth: 'Ay',
  birthdayDay: 'Gün',
  birthdayHint:
    'Yalnızca doğum gününüzde size özel bir e-posta göndermek için kullanılır (e-posta izni verdiyseniz); yıl sorulmaz. Boş bırakabilir veya istediğiniz zaman silebilirsiniz.',
  phoneOptional: 'Telefon (isteğe bağlı)',
  placeOrder: 'Siparişi ver ({{total}})',
  previewNotice: 'Önizleme: mağaza henüz yayında değil.',
  themePreviewNotice:
    'Tema önizlemesi: yayımlanmamış taslağı görüyorsunuz. Ziyaretçiler yayındaki temayı görür.',
  themePreviewExit: 'Önizlemeden çık',
  shopBySpecies: 'Türe göre ürünler',
  closeMenu: 'Menüyü kapat',
  designPreviewNotice:
    '{{experience}} için {{variant}} tasarımını önizliyorsunuz. Ziyaretçiler yayındaki tasarımı görür.',
  designPreviewExit: 'Önizlemeden çık',
  designExperiences: {
    header: 'Üst menü',
    articles: 'Makaleler',
    store_locator: 'Satış Noktaları',
    needs_finder: 'Evcil Dostumun İhtiyacı',
  },
  articles: {
    featured: 'Öne çıkan',
    latest: 'En yeni',
    latestArticles: 'Son makaleler',
    seeCategory: '{{category}}: tümünü gör',
    searchLabel: 'Makalelerde ara',
    searchPlaceholder: 'Makalelerde ara',
    resultsTitle: '"{{q}}" için makaleler',
    resultCount: '{{count}} makale bulundu',
    noResults: 'Aramanızla eşleşen makale yok. Başka bir kelime deneyin.',
    allArticles: 'Tüm makaleler',
    count: '{{count}} makale',
  },
  locator: {
    title: 'Satış Noktaları',
    metaDescription:
      'Ürünlerimizin satıldığı bayi ve mağazaları il, ilçe ve mahalleye göre bulun: adres, telefon, yol tarifi ve çalışma saatleri.',
    cityTitle: '{{city}} satış noktaları',
    cityDescription:
      '{{city}} ilindeki satış noktaları ({{count}}): adres, telefon, yol tarifi ve çalışma saatleri.',
    districtTitle: '{{district}}, {{city}} satış noktaları',
    districtDescription:
      '{{city}} {{district}} ilçesindeki satış noktaları ({{count}}): adres, telefon ve yol tarifi.',
    city: 'İl',
    district: 'İlçe',
    neighbourhood: 'Mahalle',
    allCities: 'Tüm iller',
    allDistricts: 'Tüm ilçeler',
    allNeighbourhoods: 'Tüm mahalleler',
    chooseCityFirst: 'Önce il seçin',
    optionCount: '{{name}} ({{count}})',
    search: 'Ad veya adres ara',
    searchPlaceholder: 'Mağaza adı, mahalle, cadde',
    useLocation: 'Konumumu kullan',
    geoLocating: 'Konum alınıyor…',
    geoClear: 'Yakınlık sıralamasını kaldır',
    geoPrivacy:
      'Konumunuz yalnızca bu cihazda, en yakın noktaları sıralamak için kullanılır; bize gönderilmez.',
    geoOk: 'Size en yakın noktalar üstte. Konumunuz bu cihazdan çıkmadı.',
    geoDenied: 'Konum izni verilmedi. İl ve ilçe seçerek arayabilirsiniz.',
    geoUnavailable: 'Konum alınamadı. İl ve ilçe seçerek arayabilirsiniz.',
    count: '{{count}} satış noktası',
    results: 'Satış noktaları',
    noMatch: 'Seçiminize uyan satış noktası yok.',
    noPoints: 'Henüz listelenmiş satış noktamız yok. Ürünlerimizi çevrim içi sipariş edebilirsiniz.',
    clearFilters: 'Süzgeci temizle',
    shopOnline: 'Ürünlere göz atın',
    todayOpen: 'Bugün açık: {{hours}}',
    todayClosed: 'Bugün kapalı',
    hours: 'Çalışma saatleri',
    closed: 'Kapalı',
    meters: '{{value}} m',
    km: '{{value}} km',
    directions: 'Yol tarifi',
    directionsTo: '{{name}} için yol tarifi (Google Haritalar, yeni sekmede açılır)',
    mapNote: 'Harita görsel bir özettir; aynı bilgiler süzgeçte ve listede yer alır.',
    osmAttribution: 'Konumların bir kısmı adreslerden bulunmuştur: © OpenStreetMap katkıda bulunanlar',
    allTurkey: 'Tüm Türkiye',
    showMap: 'Haritada göster',
    hideMap: 'Haritayı gizle',
    byCity: 'İllere göre',
    byDistrict: 'İlçeler',
    regions: 'Bölgeler',
  },
  product: 'Ürün',
  products: 'Ürünler',
  profile: 'Profil',
  quantity: 'Adet',
  register: 'Üye ol',
  registerTitle: 'Üye ol',
  remove: 'Kaldır',
  removeCoupon: '{{code}} kuponunu kaldır',
  requestNewLink: 'Yeni bağlantı isteyin.',
  resetSent: 'Bu e-posta adresiyle bir hesap varsa şifre belirleme bağlantısı gönderildi.',
  resetTitle: 'Yeni şifre belirleyin',
  resetUnavailable:
    'E-posta gönderimi şu an kullanılamıyor. Şifrenizi sıfırlamak için lütfen mağazayla iletişime geçin.',
  resultCount: '{{count}} ürün',
  save: 'Kaydet',
  savePassword: 'Şifreyi kaydet',
  saved: 'Kaydedildi.',
  search: 'Ara',
  searchPlaceholder: 'Ürün veya içerik ara',
  searchResults: '"{{q}}" için sonuçlar',
  sendLink: 'Bağlantı gönder',
  shipping: 'Kargo',
  shippingLater: 'Siparişte belirlenir',
  signIn: 'Giriş yap',
  signInTitle: 'Giriş yap',
  signOut: 'Çıkış yap',
  skipToContent: 'İçeriğe geç',
  sku: 'Stok kodu: {{sku}}',
  sort: 'Sıralama',
  species: 'Tür',
  status: 'Durum',
  submitApplication: 'Başvuruyu gönder',
  subtotal: 'Ara toplam',
  summary: 'Sipariş özeti',
  taxExcluded: 'KDV hariç',
  taxIncluded: 'KDV dahil',
  taxIncludedLine: 'İçindeki KDV',
  taxLine: 'KDV',
  total: 'Toplam',
  unavailableItem: 'Satışta olmayan ürün',
  verifyTitle: 'E-posta doğrulama',
  viewOrder: 'Siparişi görüntüle',
  proceedToCheckout: 'Ödemeye geç',
  shippingAtCheckout: 'Ödeme adımında hesaplanır',
  checkoutTitle: 'Ödeme',
  contactTitle: 'İletişim bilgileri',
  contactLead: 'Sipariş ve kargo bilgilendirmeleri bu adrese gönderilir.',
  memberCheckoutHint: 'Üyeyseniz giriş yapın; siparişleriniz hesabınızda görünür.',
  phone: 'Telefon',
  deliveryTitle: 'Teslimat adresi',
  newAddress: 'Başka bir adres gir',
  billingTitle: 'Fatura bilgileri',
  billingSame: 'Fatura adresi teslimat adresiyle aynı',
  corporateInvoice: 'Firma adına fatura',
  shippingTitle: 'Kargo',
  free: 'Ücretsiz',
  freeOver: '{{amount}} ve üzeri siparişlerde ücretsiz',
  estimatedDays: 'Tahmini teslim: {{days}} iş günü',
  shippingNotAvailable: 'Bu sepette kullanılamaz',
  paymentTitle: 'Ödeme yöntemi',
  installmentsUpTo: '{{count}} taksite kadar',
  codFee: 'Kapıda ödeme bedeli',
  codFeeHint: 'Hizmet bedeli: {{fee}}',
  codMaxHint: 'En fazla {{amount}} tutarındaki siparişlerde',
  codNotForShipping: 'Seçilen kargoda kapıda ödeme yok',
  creditAvailable: 'Kullanılabilir açık hesap limiti: {{amount}}',
  creditOverdueBlock: 'Vadesi geçmiş borcunuz ({{amount}}) olduğu için açık hesap şu an kullanılamıyor.',
  creditCurrencyBlock: 'Açık hesap bu para biriminde kullanılamıyor.',
  quantityRule: 'Bayi siparişi: en az {{min}} adet, {{step}} adet ve katları.',
  itemBelowMin: 'En az {{min}} adet olmalı.',
  itemNotMultiple: '{{step}} adet ve katları olmalı.',
  minOrderNotMet:
    'Bayi minimum sipariş tutarı {{min}}. Sipariş verebilmek için {{missing}} daha ürün ekleyin.',
  approval: {
    title: 'Firma Yetkilisinin onayı gerekiyor',
    request: 'Yetkilinin onayına gönder',
    noteLabel: 'Yetkiliye not (isteğe bağlı)',
    send: 'Onaya gönder',
    pending:
      '{{date}} tarihinde Yetkilinin onayına gönderildi; onay bekleniyor. Sepeti değiştirirseniz istek geçersiz olur.',
    withdraw: 'İsteği geri çek',
    rejected: '{{name}} sepeti onaylamadı.',
    reason: 'Gerekçe: {{reason}}',
    stale: 'Sepet onaya gönderildikten sonra değişti; güncel sepeti yeniden gönderin.',
    approved:
      '{{name}} bu sepeti {{date}} tarihinde onayladı. Sepeti değiştirmeden siparişi tamamlayabilirsiniz.',
    note: 'Not: {{note}}',
    ownerTitle: 'Onay bekleyen siparişler',
    ownerLead:
      'Satın alma kullanıcılarının sipariş eşiğini aşan sepetleri. Onayladığınız sepetle sipariş, kullanıcının ödeme adımından verilir.',
    nonePending: 'Onay bekleyen sipariş yok.',
    requestOf: '{{name}} kullanıcısının onay isteği',
    goodsTotal: 'Ürün toplamı: {{total}}',
    requestNote: 'Not: {{note}}',
    approve: 'Onayla',
    reject: 'Reddet',
    rejectReason: 'Ret gerekçesi',
    rejectSubmit: 'Gerekçeyle reddet',
    approvedDone: '{{name}} kullanıcısının sepeti onaylandı.',
    rejectedDone: '{{name}} kullanıcısının sepeti reddedildi.',
    history: 'Sonuçlanan istekler',
    requester: 'İsteyen',
    statuses: {
      pending: 'Bekliyor',
      approved: 'Onaylandı',
      rejected: 'Reddedildi',
      cancelled: 'Geri çekildi',
      used: 'Siparişe dönüştü',
    },
    orderLine: 'Firma onayı: {{name}}',
  },
  po: {
    title: 'Satın alma emri (PO)',
    lead: {
      none: 'İsteğe bağlı: firmanızın satın alma emri numarasını ve belgesini ekleyebilirsiniz.',
      number: 'Firmanız siparişte satın alma emri (PO) numarası istiyor.',
      number_and_document: 'Firmanız siparişte satın alma emri (PO) numarası ve belgesi istiyor.',
    },
    number: 'PO numarası',
    numberOptional: 'PO numarası (isteğe bağlı)',
    document: 'PO belgesi',
    documentOptional: 'PO belgesi (isteğe bağlı)',
    documentHint: 'PDF, JPEG veya PNG; en çok 10 MB. Belgeyi yalnızca mağaza görür.',
    uploaded: '{{name}} eklendi.',
    remove: 'Kaldır',
    missing: 'Siparişi onaylamak için satın alma emri bilgilerini tamamlayın.',
    listLabel: 'PO: {{number}}',
    orderLine: 'Satın alma emri: {{number}}',
    orderDocument: 'belge: {{name}}',
  },
  quotes: {
    title: 'Teklifler',
    linkLead: 'İstediğiniz ve size gönderilen fiyat teklifleri',
    detailTitle: 'Teklif {{number}}',
    empty: 'Henüz teklif yok. Sepetteyken "Teklif iste" ile fiyat teklifi isteyebilirsiniz.',
    number: 'Teklif no',
    validUntil: 'Geçerlilik',
    validUntilLine: '{{date}} tarihine kadar geçerli',
    versionLine: '{{version}}. sürüm',
    statuses: {
      requested: 'İsteğiniz alındı',
      draft: 'Hazırlanıyor',
      sent: 'Kabulünüzü bekliyor',
      ordered: 'Siparişe dönüştü',
      rejected: 'Reddettiniz',
      cancelled: 'İptal edildi',
      expired: 'Süresi doldu',
    },
    requestedLead: 'Teklif isteğiniz alındı. Mağaza fiyatı hazırlayıp gönderince burada görünür.',
    draftLead:
      'Teklif mağaza tarafından hazırlanıyor veya güncelleniyor; gönderildiğinde kabul edebilirsiniz.',
    rejectedLead: 'Teklifi reddettiniz: {{reason}}',
    expiredLead: 'Teklifin süresi doldu; kabul edilemez. Yeni teklif için mağazayla iletişime geçin.',
    note: 'Mağazanın notu',
    requestNoteLine: 'İstek notunuz: {{note}}',
    lines: 'Teklif edilen ürünler',
    product: 'Ürün',
    listPrice: 'Liste fiyatı',
    unitPrice: 'Teklif fiyatı',
    taxIncl: 'KDV dahil',
    taxExcl: 'KDV hariç',
    taxLine: 'KDV: {{tax}}',
    saving: 'Liste fiyatına göre indirim: {{amount}}',
    shippingNote: 'Kargo ve ödeme yöntemi sipariş verirken seçilir.',
    accept: 'Kabul et ve sipariş ver',
    acceptLead:
      'Kabul edince sepetiniz bu teklifle değiştirilir (sepetteki diğer ürünler çıkarılır) ve ödeme adımına geçersiniz; fiyatlar teklife göredir.',
    reject: 'Reddet',
    rejectReason: 'Ret gerekçesi',
    confirmReject: 'Teklifi reddet',
    print: 'Yazdır',
    view: 'Teklifi gör',
    inCart:
      'Sepette {{number}} numaralı teklif var ({{version}}. sürüm, {{date}} tarihine kadar geçerli). Fiyatlar teklife göredir; sepet değiştirilemez.',
    release: 'Teklifi sepetten çıkar',
    request: 'Teklif iste',
    requestLead:
      'Sepetteki ürünler için mağazadan özel fiyat teklifi istenir. Sepetiniz değişmez; teklif hazırlanınca Hesabım → Teklifler’de görünür.',
    requestNote: 'Notunuz (isteğe bağlı)',
    sendRequest: 'Teklif isteği gönder',
    requested: '{{number}} numaralı teklif isteğiniz alındı.',
  },
  quickOrder: {
    title: 'Hızlı sipariş',
    linkLead: 'Stok kodu ve adetle toplu sipariş',
    lead: 'Her satıra bir stok kodu ve adet yazın (ör. "ZG-OM-60;12"). Excel’den iki sütunu kopyalayıp yapıştırabilir veya CSV dosyası seçebilirsiniz. Önce kontrol edin; sorunsuz satırlar sepete eklenir.',
    lines: 'Stok kodu ve adet (her satıra bir ürün)',
    file: 'veya CSV dosyası seçin',
    check: 'Kontrol et',
    addToCart: '{{count}} ürünü sepete ekle',
    preview: 'Kontrol sonucu',
    sku: 'Stok kodu',
    product: 'Ürün',
    unitPrice: 'Birim fiyat',
    ok: 'Eklenebilir',
    added: '{{count}} ürün sepete eklendi.',
    empty: 'Okunabilir satır yok. Her satıra stok kodu ve adet yazın.',
    badLines: 'Okunamayan satırlar atlandı: {{lines}} (adet 1–999 olmalı).',
    dealersOnly: 'Hızlı sipariş bayi hesaplarına açıktır.',
    statuses: {
      not_found: 'Stok kodu bulunamadı',
      unavailable: 'Satışta değil',
      insufficient_stock: 'Stok yetersiz (en fazla {{available}})',
      below_min_quantity: 'En az {{min}} adet',
      not_pack_multiple: '{{step}} adet ve katları',
      cart_line_limit: 'Sepet en çok {{max}} farklı ürün alır',
    },
  },
  reorder: {
    title: 'Tekrar sipariş',
    button: 'Bu siparişi tekrarla',
    added: '{{count}} ürün bugünkü fiyatıyla sepete eklendi.',
  },
  companyLocation: 'Firma: {{label}}',
  companyInvoiceNote: 'Fatura firma unvanı, vergi dairesi ve vergi numarasıyla kesilir.',
  memberLimit:
    'Sipariş eşiğiniz: {{amount}} (kargo dahil). Bu tutarı aşan sipariş için firma Yetkilisinin onayı gerekir.',
  company: {
    title: 'Firmam',
    roles: { owner: 'Yetkili', buyer: 'Satın alma', viewer: 'Yalnızca görüntüleme' },
    roleHelp: {
      owner:
        'Firma adına sipariş verirsiniz; firma siparişlerini, cari hesabı ve kullanıcıları görür, lokasyonları yönetirsiniz.',
      buyer: 'Firma adına sipariş verirsiniz; kendi siparişlerinizi görürsünüz.',
      viewer: 'Bayi fiyatlarını, firma siparişlerini ve cari hesabı görürsünüz; sipariş veremezsiniz.',
    },
    locations: 'Lokasyonlar (şube, teslimat, fatura)',
    noLocations: 'Henüz lokasyon yok.',
    addLocation: 'Lokasyon ekle',
    editLocation: 'Lokasyonu düzenle',
    edit: 'Düzenle',
    delete: 'Sil',
    confirmDelete: '"{{name}}" lokasyonu silinsin mi? Geçmiş siparişlerdeki adres değişmez.',
    deleted: 'Lokasyon silindi.',
    saved: 'Lokasyon kaydedildi.',
    locationLabel: 'Lokasyon adı (ör. Merkez, Kadıköy şubesi)',
    defaultShipping: 'varsayılan teslimat',
    defaultBilling: 'varsayılan fatura',
    makeDefaultShipping: 'Varsayılan teslimat adresi yap',
    makeDefaultBilling: 'Varsayılan fatura adresi yap',
    saveLocation: 'Lokasyonu kaydet',
    members: 'Firma kullanıcıları',
    membersLead:
      'Mağazada zaten hesabı olan birini firmanıza eklemek veya kendi rolünüzü değiştirmek için mağazayla iletişime geçin.',
    memberName: 'Kullanıcı',
    role: 'Rol',
    limit: 'Sipariş eşiği',
    notActivated: 'hesabını etkinleştirmedi',
    actions: 'İşlemler',
    you: '(siz)',
    memberEdit: 'Düzenle',
    memberEditFor: 'Düzenle: {{name}}',
    memberFormFor: '{{name}}: rol ve eşik',
    memberSave: 'Kaydet',
    memberSaved: '{{name}} güncellendi.',
    remove: 'Firmadan çıkar',
    removeFor: 'Firmadan çıkar: {{name}}',
    removeConfirm:
      '{{name}} firmadan çıkarılsın mı? Hesabı silinmez; bayi fiyatlarını ve firma bilgilerini artık göremez.',
    removed: '{{name}} firmadan çıkarıldı.',
    resendLink: 'Bağlantıyı yeniden gönder',
    resendLinkFor: 'Bağlantıyı yeniden gönder: {{name}}',
    linkResent: '{{email}} adresine yeni etkinleştirme bağlantısı gönderildi; eski bağlantı geçersiz oldu.',
    limitField: 'Sipariş eşiği (TL)',
    limitHint: 'Bu tutarı aşan sepet sizin onayınıza gelir. Boş bırakırsanız eşik olmaz.',
    limitInvalid: 'Tutarı 5.000 veya 2.500,50 biçiminde yazın.',
    inviteTitle: 'Kullanıcı davet et',
    inviteLead:
      'Davet edilen kişiye etkinleştirme bağlantısı e-postayla gider; şifresini kendisi belirler. Günde en çok {{perDay}} davet gönderebilirsiniz.',
    inviteName: 'Ad soyad',
    inviteEmail: 'E-posta',
    invitePhone: 'Telefon (isteğe bağlı)',
    inviteSubmit: 'Davet gönder',
    invited: '{{email}} adresine davet gönderildi.',
    inviteSetupRequired:
      'Kurulum Gerekli: mağazanın e-posta altyapısı henüz kurulmadığı için davet gönderilemiyor. Kullanıcı eklemek için mağazayla iletişime geçin.',
    orders: 'Firma siparişleri',
    placedBy: 'Veren',
    companyOrderNote:
      'Bu sipariş firmanızın başka bir kullanıcısına ait; yalnızca görüntüleyebilirsiniz. İade ve ödeme işlemlerini siparişi veren kişi yapar.',
  },
  balancePay: {
    open: 'Kartla öde',
    title: 'Kartla bakiye ödemesi',
    modeBalance: 'Bakiyenin tamamı ({{amount}})',
    modeItems: 'Seçtiğim kalemler',
    modeCustom: 'Başka bir tutar',
    itemLabel: '{{item}} — {{amount}}',
    amountLabel: 'Tutar ({{currency}})',
    amountHint: 'En çok {{max}} ödeyebilirsiniz.',
    amountInvalid: 'Tutarı 1.250,50 biçiminde yazın.',
    lead: 'Ödeme, ödeme kuruluşunun güvenli sayfasında alınır (en çok {{installments}} taksit). Ödemeniz cari hesabınıza tahsilat olarak işlenir ve en eski vadeli borcunuza uygulanır.',
    submit: '{{amount}} öde',
    unavailable: 'Kartla ödeme şu anda kullanılamıyor. Bakiyenizi havale/EFT ile ödeyebilirsiniz.',
    recent: 'Son kartla ödemeleriniz',
    amount: 'Tutar',
    status: 'Durum',
    statuses: {
      pending: 'Bekleniyor',
      captured: 'Alındı',
      failed: 'Alınamadı',
      expired: 'Süresi doldu',
      requires_action: 'İnceleniyor',
    },
    resultTitle: 'Cari hesap ödemesi',
    notFound: 'Ödeme bulunamadı.',
    result: {
      pending: 'Ödemeniz kontrol ediliyor…',
      captured: '{{amount}} ödemeniz alındı ve cari hesabınıza işlendi.',
      failed: 'Ödeme alınamadı. Kartınızdan çekim yapılmadı; yeniden deneyebilirsiniz.',
      expired: 'Ödeme tamamlanmadı. Kartınızdan çekim yapılmadı; yeniden deneyebilirsiniz.',
      requires_action:
        'Ödemeniz inceleniyor. Sonuç cari hesabınıza yansıyacak; gerekirse sizinle iletişime geçeceğiz.',
    },
    backToAccount: 'Cari hesabıma dön',
  },
  dealerLedger: {
    bhPendingPayments: 'Muhasebeye henüz yansımamış ödemeleriniz',
    bhPending: 'Muhasebeye henüz aktarılmamış siparişler',
    bhSource: 'Bakiye ve hareketler muhasebe kaydımızdan (BizimHesap), son güncelleme {{date}}.',
    bhNever: 'Muhasebe kaydı (BizimHesap) henüz alınamadı.',
    bhStale: 'Şu anda güncellenemedi; son alınan kayıt gösteriliyor.',
    bhStatement: 'Hesap ekstresi (muhasebe kaydı)',
    siteStatement: 'Bu sitedeki sipariş ve tahsilat hareketleri',
    title: 'Cari hesabım',
    lead: 'Açık hesap siparişlerinizin vadesi sipariş tarihinden {{days}} gün sonradır. Ödemeleriniz en eski vadeli borca uygulanır.',
    leadNoTerm: 'Ödemeleriniz en eski vadeli borca uygulanır.',
    balance: 'Bakiye (borcunuz)',
    overdue: 'Vadesi geçen',
    available: 'Kullanılabilir açık hesap limiti',
    openItems: 'Ödenmemiş kalemler',
    item: 'Sipariş / kayıt',
    dueDate: 'Vade',
    open: 'Kalan',
    daysOverdue: '{{days}} gün geçti',
    statement: 'Hesap ekstresi (son 12 ay)',
    date: 'Tarih',
    description: 'Açıklama',
    debit: 'Borç',
    credit: 'Alacak',
    running: 'Bakiye',
    broughtForward: 'Devir (dönem başı bakiye)',
    download: 'Ekstreyi indir (CSV)',
    kinds: {
      order: 'Sipariş',
      order_change: 'Sipariş değişikliği',
      order_payment: 'Sipariş ödemesi',
      payment: 'Ödeme',
      opening: 'Açılış bakiyesi',
      adjustment: 'Düzeltme',
      reversal: 'Düzeltme (ters kayıt)',
    },
    reasons: {
      placed: 'Sipariş verildi',
      cancelled: 'İptal',
      partial_cancel: 'Kısmi iptal',
      edited: 'Sipariş düzenlendi',
      refunded: 'İade',
      paid: 'Ödeme alındı',
      refund_paid: 'İade ödemesi',
      changed: 'Tutar değişti',
      card_balance: 'Kartla ödeme',
    },
  },
  contractsTitle: 'Ön bilgilendirme ve sözleşme',
  contractsLead:
    'Siparişi onaylamadan önce aşağıdaki metinleri okuyun. Onayladığınız metinler siparişinizle birlikte saklanır; sipariş sayfanızdan her zaman görebilirsiniz.',
  fillToSeeContracts:
    'Adres, kargo ve ödeme yöntemini seçtiğinizde tutarlar ve sözleşme metinleri burada görünür.',
  quoteUpdating: 'Tutarlar güncelleniyor…',
  confirmAndPay: 'Siparişi onayla ve öde · {{total}}',
  confirmOrder: 'Siparişi onayla · {{total}}',
  placingOrder: 'Sipariş oluşturuluyor…',
  orderReceivedTitle: 'Siparişiniz alındı',
  orderReceivedLead: 'Sipariş numaranız {{number}}.',
  customerService: 'Müşteri hizmetleri',
  contactPageTitle: 'İletişim',
  contactForm: {
    title: 'Bize yazın',
    presets: {
      name: 'Adınız soyadınız',
      email: 'E-posta adresiniz',
      phone: 'Telefon',
      message: 'Mesajınız',
    },
    submit: 'Gönder',
    sent: 'Mesajınız alındı. En kısa sürede e-postayla yanıt vereceğiz.',
    trap: 'Bu alanı boş bırakın',
  },
  formChoose: 'Seçin',
  formPrivacy: 'Kişisel verileriniz yalnızca talebinizi yanıtlamak için işlenir. Ayrıntılı bilgi:',
  phoneLabel: 'Telefon',
  emailLabel: 'E-posta',
  contactOrderHint:
    'Bir siparişiniz hakkında yazıyorsanız sipariş numaranızı ekleyin. Siparişinizi görüntülemek için:',
  orderLookupTitle: 'Sipariş sorgulama',
  stockAlert: {
    open: 'Gelince haber ver',
    lead: 'Bu seçenek stoğa girince size bir kez e-posta gönderelim. Üyelik gerekmez.',
    email: 'E-posta',
    notice:
      'Adresiniz yalnızca bu bildirim için kullanılır; ürün stoğa girince tek bir e-posta gönderilir ve talep 6 ay geçerlidir. Reklam iletisi gönderilmez.',
    submit: 'Haber ver',
    sent: 'Tamam. Ürün stoğa girince size e-posta göndereceğiz.',
  },
  tender: {
    title: 'Hediye kartı veya mağaza kredisi',
    giftCard: 'Hediye kartı kodu',
    apply: 'Uygula',
    remove: 'Kartı kaldır',
    applied: 'Hediye kartı …{{last4}} uygulandı (bakiye {{balance}}).',
    useCredit: 'Mağaza kredimi kullan ({{balance}})',
    coveredHint: 'Tutarın tamamı karşılanırsa seçtiğiniz ödeme yöntemi kullanılmaz.',
    giftCardLine: 'Hediye kartı (…{{last4}})',
    storeCreditLine: 'Mağaza kredisi',
    due: 'Ödenecek tutar',
    confirmCovered: 'Siparişi onayla (ödenecek tutar kalmadı)',
  },
  credit: {
    title: 'Mağaza kredim',
    lead: 'Mağaza kredinizi ödeme adımında "Mağaza kredimi kullan" ile harcayabilirsiniz.',
    history: 'Mağaza kredisi hareketleri',
    date: 'Tarih',
    kind: 'İşlem',
    amount: 'Tutar',
    kinds: {
      grant: 'Mağaza tarafından eklendi',
      refund: 'İade krediye eklendi',
      redeem: 'Siparişte kullanıldı',
      release: 'İptal edilen siparişten geri',
      adjust: 'Düzeltme',
    },
  },
  loyalty: {
    tierLine: '{{tier}} üye indirimi (%{{percent}})',
    tierShipping: '{{tier}} üyeliği: ücretsiz kargo',
    usePoints: 'Puanlarımı kullan ({{points}} puan = {{value}})',
    minRedeem: 'Puan kullanmak için en az {{points}} puan gerekir (şu an {{balance}} puan).',
    pointsLine: 'Sadakat puanı ({{points}} puan)',
    earn: 'Bu siparişten {{points}} puan kazanacaksınız; puanlar teslimden {{days}} gün sonra hesabınıza geçer.',
    earnNow: 'Bu siparişten {{points}} puan kazanacaksınız; puanlar teslimden sonra hesabınıza geçer.',
    title: 'Puanlarım',
    balance: '{{points}} puan',
    balanceValue: '{{value}} değerinde; ödeme adımında "Puanlarımı kullan" ile harcayabilirsiniz.',
    tier: 'Seviyeniz: {{tier}}',
    noTier: 'Henüz bir seviyeniz yok.',
    perks: 'Ayrıcalıklarınız: {{perks}}',
    perkDiscount: '%{{percent}} indirim',
    perkShipping: 'ücretsiz kargo',
    nextTier: '{{tier}} seviyesine {{amount}} kaldı (son 12 ayda {{spent}} alışveriş).',
    topTier: 'En üst seviyedesiniz (son 12 ayda {{spent}} alışveriş).',
    expiring: '{{points}} puanın süresi 30 gün içinde doluyor.',
    rules: 'Program koşulları',
    ruleEarn: 'Her {{one}} alışverişe {{points}} puan kazanırsınız (kargo ve puanla ödenen kısım hariç).',
    ruleValue: '{{points}} puan = {{one}}.',
    ruleHold: 'Puanlar teslimden {{days}} gün sonra hesabınıza geçer.',
    ruleHoldNow: 'Puanlar teslimden sonra hesabınıza geçer.',
    ruleExpiry: 'Kazanılan puanlar {{months}} ay geçerlidir; önce süresi dolacak puan harcanır.',
    ruleNoExpiry: 'Puanların süresi dolmaz.',
    ruleMin: 'Ödemede kullanmak için en az {{points}} puan gerekir.',
    ruleRefund:
      'İade edilen tutarın puanı geri alınır; iptal edilen siparişte kullanılan puan geri yüklenir.',
    tiersTitle: 'Seviyeler (son 12 aydaki alışverişe göre)',
    tierRow: '{{tier}}: {{min}} ve üzeri',
    history: 'Puan hareketleri',
    date: 'Tarih',
    kind: 'İşlem',
    points: 'Puan',
    kinds: {
      earn: 'Kazanıldı',
      redeem: 'Siparişte kullanıldı',
      release: 'Geri yüklendi',
      reverse: 'İade nedeniyle geri alındı',
      expire: 'Süresi doldu',
      adjust: 'Düzeltme',
    },
  },
  referral: {
    title: 'Arkadaşını davet et',
    lead: 'Davet kodunuzla ilk siparişini veren arkadaşınız {{friend}} kazanır. Arkadaşınızın siparişi teslim edildikten {{days}} gün sonra size {{referrer}} kuponu verilir.',
    leadNow:
      'Davet kodunuzla ilk siparişini veren arkadaşınız {{friend}} kazanır. Arkadaşınızın siparişi teslim edildikten sonra size {{referrer}} kuponu verilir.',
    offerPercent: '%{{percent}} indirim',
    offerFixed: '{{value}} indirim',
    offerMin: '{{offer}} ({{min}} ve üzeri alışverişte)',
    getCode: 'Davet kodumu al',
    yourCode: 'Davet kodunuz:',
    link: 'Davet bağlantınız',
    copy: 'Bağlantıyı kopyala',
    share: 'Paylaş',
    shareTitle: 'İlk siparişinde indirim için davet bağlantım',
    copied: 'Bağlantı kopyalandı.',
    copyFailed: 'Kopyalanamadı; bağlantıyı seçip kendiniz kopyalayın.',
    stats: 'Bekleyen davet: {{pending}}. Kazanılan ödül: {{rewarded}}.',
    rules: 'Program koşulları',
    ruleFirst: 'İndirim yalnızca arkadaşınızın ilk siparişinde geçerlidir. Kendi kodunuzu kullanamazsınız.',
    ruleHold:
      'Ödül, arkadaşınızın siparişi teslim edildikten {{days}} gün sonra verilir. Sipariş iptal veya iade edilirse ödül verilmez.',
    ruleHoldNow:
      'Ödül, arkadaşınızın siparişi teslim edildikten sonra verilir. Sipariş iptal veya iade edilirse ödül verilmez.',
    ruleValid: 'Ödül kuponu {{days}} gün geçerlidir ve yalnızca sizin hesabınızda kullanılabilir.',
    ruleMax: 'En çok {{max}} ödül kazanabilirsiniz.',
    ruleNoContact: 'Mağaza arkadaşınıza sizin adınıza mesaj göndermez; bağlantıyı siz paylaşırsınız.',
    rewardsTitle: 'Ödül kuponlarınız',
    code: 'Kod',
    discount: 'İndirim',
    endsAt: 'Son kullanma',
    state: 'Durum',
    states: { active: 'Kullanılabilir', used: 'Kullanıldı', expired: 'Süresi doldu' },
    inviteTitle: 'Davetlisiniz',
    inviteLead: 'Bir arkadaşınız sizi davet etti. İlk siparişinizde {{offer}} kazanırsınız.',
    inviteCode: 'Davet kodu:',
    inviteHow:
      'Kod sepetinizde kendiliğinden uygulanır; isterseniz sepetteki "Kupon kodu" alanına kendiniz de yazabilirsiniz. İndirim yalnızca ilk siparişte geçerlidir.',
    inviteStart: 'Alışverişe başla',
  },
  support: {
    title: 'Destek taleplerim',
    empty: 'Henüz destek talebiniz yok.',
    newTicket: 'Yeni talep',
    colTicket: 'Talep',
    colStatus: 'Durum',
    colUpdated: 'Son güncelleme',
    category: 'Konu',
    subject: 'Başlık',
    order: 'İlgili sipariş (isteğe bağlı)',
    noOrder: 'Sipariş seçmeyin',
    message: 'Mesajınız',
    messageHint: 'Kart numarası, şifre veya doğrulama kodu yazmayın; bunları sizden hiçbir zaman istemeyiz.',
    submit: 'Talebi gönder',
    cancel: 'Vazgeç',
    categories: {
      order: 'Sipariş',
      shipping: 'Kargo ve teslimat',
      return: 'İade ve değişim',
      payment: 'Ödeme ve fatura',
      product: 'Ürün bilgisi',
      account: 'Hesap',
      other: 'Diğer',
    },
    statuses: {
      open: 'İnceleniyor',
      waiting: 'Yanıtınız bekleniyor',
      resolved: 'Çözüldü',
      closed: 'Kapatıldı',
    },
    awaitingRating: 'Puanınızı bekliyoruz',
    ticketTitle: 'Destek talebi #{{number}}',
    orderLine: 'Sipariş {{number}}',
    conversation: 'Yazışma',
    you: 'Siz',
    team: 'Destek ekibi',
    resolvedNote:
      'Talebiniz çözüldü olarak işaretlendi. Sorun devam ediyorsa yazmanız yeterli; talep yeniden açılır.',
    closedNote: 'Bu talep kapatıldı. Yeni bir konu için Hesabım sayfasından yeni talep açabilirsiniz.',
    reply: 'Yanıtınız',
    sendReply: 'Yanıtı gönder',
    replySent: 'Yanıtınız gönderildi.',
    rateTitle: 'Yardımımızı puanlayın',
    rateLead: '1 (hiç memnun değilim) ile 5 (çok memnunum) arasında bir puan seçin.',
    score: '{{score}} puan',
    comment: 'Yorumunuz (isteğe bağlı)',
    sendRating: 'Puanı gönder',
    ratingSent: 'Değerlendirmeniz alındı.',
    thanks: 'Değerlendirmeniz için teşekkürler: {{rating}} / 5',
    notFound:
      'Talep bulunamadı. E-postadaki bağlantının tamamını kullandığınızdan emin olun; üyeyseniz giriş yapın.',
    keepLink: 'Bu sayfanın bağlantısı size özeldir; başkalarıyla paylaşmayın.',
  },
  chat: {
    launcher: 'Canlı destek',
    title: 'Canlı destek',
    close: 'Kapat',
    unavailable: 'Canlı destek şu anda kapalı. Bize iletişim sayfasından yazabilirsiniz:',
    nobody: 'Şu anda çevrimiçi temsilcimiz yok. Bize iletişim sayfasından yazabilirsiniz:',
    sent: 'Mesajınız alındı ve destek talebi olarak kaydedildi. Yanıtımızı e-posta adresinize göndereceğiz.',
    startLead: 'Sorunuzu yazın; bir temsilcimiz birazdan yanıtlayacak.',
    offlineLead: 'Şu anda çevrimiçi temsilcimiz yok. Mesajınızı bırakın, e-postayla yanıtlayalım.',
    nameOptional: 'Adınız (isteğe bağlı)',
    name: 'Adınız',
    emailOptional: 'E-posta (isteğe bağlı)',
    email: 'E-posta',
    emailHint: 'Sohbet kesilirse size bu adresten dönebiliriz.',
    emailOfflineHint: 'Yanıtımızı bu adrese göndereceğiz.',
    message: 'Mesajınız',
    privacy:
      'Kart numarası, şifre veya doğrulama kodu yazmayın. Yazdıklarınız yalnızca sorunuzu yanıtlamak için işlenir:',
    start: 'Sohbeti başlat',
    leave: 'Mesajı gönder',
    messages: 'Sohbet mesajları',
    team: 'Destek ekibi',
    you: 'Siz',
    events: {
      joined: 'Bir temsilcimiz sohbete katıldı.',
      closed_visitor: 'Sohbeti bitirdiniz.',
      closed_staff: 'Temsilcimiz sohbeti kapattı.',
      closed_idle: 'Sohbet hareketsizlik nedeniyle kapandı.',
      ticket: 'Sohbetiniz destek talebi olarak kaydedildi; size e-postayla döneceğiz.',
    },
    waiting: 'Sırada {{position}}. kişisiniz; bir temsilcimiz birazdan bağlanacak.',
    closedTicket: 'Sohbet kapandı; konunuz destek talebi olarak kaydedildi.',
    closed: 'Sohbet kapandı.',
    newChat: 'Yeni sohbet',
    yourMessage: 'Mesajınız',
    send: 'Gönder',
    end: 'Sohbeti bitir',
  },
  promo: {
    title: 'Kampanyalar',
    itemDiscount: 'Sepette %{{percent}} indirim',
    buyXPayY: '{{buy}} al {{pay}} öde: her {{buy}} üründe en düşük fiyatlı {{free}} ürün bedava',
    tierSubtotalPercent: '{{min}} ve üzeri sepette %{{percent}} indirim',
    tierSubtotalFixed: '{{min}} ve üzeri sepette {{value}} indirim',
    tierQuantityPercent: '{{min}} ve üzeri üründe sepette %{{percent}} indirim',
    tierQuantityFixed: '{{min}} ve üzeri üründe sepette {{value}} indirim',
    freeShippingOver: '{{min}} ve üzeri siparişte kargo bedava',
    freeShipping: 'Kargo bedava',
    until: '{{date}} tarihine kadar',
    targeted: 'Kampanya bu üründe geçerlidir; indirim sepette uygulanır.',
    hintPercent: '{{amount}} daha ekleyin, sepette %{{percent}} indirim kazanın.',
    hintFixed: '{{amount}} daha ekleyin, sepette {{value}} indirim kazanın.',
    hintShipping: '{{amount}} daha ekleyin, kargo bedava.',
    shippingFree: 'Kargo bedava',
    coupon: 'Kupon ({{code}})',
  },
  push: {
    title: 'Tarayıcı bildirimleri',
    lead: 'Kampanya ve yeni ürünlerden bildirimle haberdar olun. İzin yalnızca siz düğmeye basınca istenir; istediğiniz an kapatabilirsiniz.',
    enable: 'Bildirimleri aç',
    disable: 'Bildirimleri kapat',
    enabled: 'Bildirimler bu tarayıcıda açık.',
    disabled: 'Bildirimler kapatıldı.',
    denied:
      'Tarayıcınız bu site için bildirimleri engelliyor. Açmak için tarayıcı ayarlarından site iznini değiştirin.',
    failed: 'Bildirimler açılamadı. Daha sonra tekrar deneyin.',
    privacy: 'Aydınlatma metni',
  },
  newsletter: {
    title: 'E-posta bülteni',
    lead: 'Kampanya, yeni ürün ve içeriklerden haberdar olun. İstediğiniz zaman tek tıkla çıkabilirsiniz.',
    email: 'E-posta adresiniz',
    consent:
      'Kampanya, duyuru ve yeniliklerden e-postayla haberdar olmak için ticari elektronik ileti almayı kabul ediyorum.',
    privacy: 'Aydınlatma metni',
    submit: 'Abone ol',
    sent: 'Teşekkürler. Aboneliği başlatmak için e-posta adresinize gönderdiğimiz bağlantıyı açın (7 gün geçerli). E-posta gelmediyse istenmeyen klasörüne bakın.',
    confirmTitle: 'Bülten aboneliğini onaylayın',
    confirmLead: 'Bu adrese bülten göndermemize onay vermek için aşağıdaki düğmeye basın.',
    confirm: 'Aboneliği onayla',
    confirmed: 'Aboneliğiniz başladı. Her bültenin altındaki bağlantıyla istediğiniz zaman çıkabilirsiniz.',
    missingToken: 'Bağlantı eksik. E-postadaki bağlantıyı eksiksiz açın.',
    unsubscribeTitle: 'Pazarlama iletilerinden çık',
    unsubscribeLead: '{{address}} adresine pazarlama iletisi göndermeyi durduracağız.',
    unsubscribeLeadSms: '{{address}} numarasına pazarlama mesajı göndermeyi durduracağız.',
    unsubscribe: 'İletilerden çık',
    unsubscribed:
      'Çıkış yapıldı: {{address}} adresine artık pazarlama iletisi göndermeyeceğiz. Sipariş ve kargo bildirimleri gelmeye devam eder.',
    memberHint: 'Üyeyseniz izinlerinizi Hesabım sayfasındaki ileti izinlerinden de değiştirebilirsiniz.',
  },
  orderLookupLead:
    'Sipariş numaranızı ve siparişte kullandığınız e-posta adresini girin. Bilgiler eşleşirse sipariş bağlantınız e-postanıza gönderilir.',
  orderLookupMember: 'Üye olarak sipariş verdiyseniz siparişlerinizi hesabınızda görebilirsiniz:',
  orderNumber: 'Sipariş numarası',
  orderLookupSubmit: 'Bağlantıyı gönder',
  orderLookupSent:
    'Bilgiler bir siparişle eşleşiyorsa sipariş bağlantısı birkaç dakika içinde e-postanıza gelir. Gelmezse spam klasörünü kontrol edin.',
  orderLookupUnavailable:
    'Şu anda e-posta gönderilemiyor. Siparişiniz için lütfen iletişim sayfasındaki bilgilerden bize ulaşın.',
  bankAccountsTitle: 'Banka hesaplarımız',
  bankAccountsLead: 'Havale/EFT yaparken açıklamaya sipariş numaranızı (veya bayi kodunuzu) yazın.',
  bankAccountsEmpty: 'Henüz banka hesabı bilgisi eklenmedi.',
  returnsTitle: 'İade, cayma ve değişim',
  returnLead:
    'Ürünü iade etmek veya cayma hakkınızı kullanmak için talep oluşturun; talebiniz incelenip size e-postayla dönülür. Koşullar:',
  returnPolicyLink: 'İade ve cayma koşulları',
  returnStart: 'İade / cayma talebi oluştur',
  returnStartExchange: 'İade, cayma veya değişim talebi oluştur',
  returnResolution: 'Ne istiyorsunuz?',
  returnResolutions: {
    refund: 'Para iadesi',
    exchange: 'Değişim (aynı ürünün başka bir seçeneği)',
  },
  exchangeHint:
    'Değişim aynı fiyatlı ve stokta olan seçeneklerle yapılır; ek ücret alınmaz. Fiyatı farklı bir seçenek için iade talebi oluşturup yeni sipariş verebilirsiniz.',
  exchangeItemsLabel: 'Değiştirilecek ürünler, adet ve yerine istediğiniz seçenek',
  exchangeFor: '{{title}} yerine istediğiniz seçenek',
  exchangeChoose: 'Seçenek seçin',
  exchangeItems: 'Yerine gönderilecek: {{items}}',
  exchangeShipped: 'Değişim ürünü kargoya verildi. Takip numarası: {{number}}',
  cancelledQty: '{{count}} adet gönderilemedi, iptal edildi',
  cancelledItems: 'İptal edilen ürünler',
  chooseProvince: 'İl seçin',
  chooseDistrict: 'İlçe seçin',
  chooseProvinceFirst: 'Önce il seçin',
  returnKind: 'Talep türü',
  returnItems: 'İade edilecek ürünler ve adet',
  returnQuantityFor: '{{title}} iade adedi',
  returnNote: 'Açıklama (isteğe bağlı)',
  returnSubmit: 'Talebi gönder',
  returnSent:
    'Talebiniz alındı. İncelendikten sonra e-postayla bilgi verilecek; ürünü göndermeden önce bu dönüşü bekleyin.',
  returnKinds: {
    withdrawal: 'Cayma hakkı (fikrimi değiştirdim)',
    defective: 'Hasarlı / kusurlu ürün',
    wrong_item: 'Yanlış ürün gönderildi',
    other: 'Diğer',
  },
  returnStatuses: {
    requested: 'İnceleniyor',
    approved: 'Onaylandı',
    rejected: 'Kabul edilmedi',
    completed: 'Tamamlandı',
    cancelled: 'İptal edildi',
  },
  bankTransferTitle: 'Havale/EFT bilgileri',
  bankTransferLead:
    'Lütfen {{amount}} tutarını aşağıdaki hesaplardan birine gönderin ve açıklamaya sipariş numaranızı yazın. Ödemeniz hesabımıza geçtiğinde siparişiniz hazırlanır.',
  bankTransferDeadline:
    'Ödemeniz {{deadline}} tarihine kadar hesabımıza geçmezse siparişiniz kendiliğinden iptal edilir.',
  bank: 'Banka',
  accountHolder: 'Alıcı',
  iban: 'IBAN',
  transferDescription: 'Açıklama',
  copy: 'Kopyala',
  copied: 'Kopyalandı',
  payRedirecting: 'Güvenli ödeme sayfasına yönlendiriliyorsunuz…',
  payFrameTitle: 'Güvenli ödeme',
  payFrameMissing:
    'Kart ödeme formu açılamadı (süresi dolmuş veya başka bir sekmede açılmış olabilir). Siparişinizi sorgulayıp ödemeyi yeniden başlatabilirsiniz.',
  payFrameLead: 'Kart bilgileriniz ödeme kuruluşunun güvenli formunda girilir; mağaza kart bilgisi görmez.',
  payFrameReturn: 'Ödeme sonucunu görmek için devam edin',
  paymentInitFailed: 'Ödeme sayfası açılamadı. Siparişiniz kaydedildi; yeniden deneyebilirsiniz.',
  retryPayment: 'Ödemeyi yeniden dene',
  paymentResultTitle: 'Ödeme sonucu',
  paymentChecking: 'Ödemeniz kontrol ediliyor…',
  paymentSuccess: 'Ödemeniz alındı. Siparişiniz hazırlanıyor.',
  paymentAuthorized: 'Siparişiniz onaylandı.',
  paymentAuthorizedLead:
    '{{number}} numaralı siparişinizin tutarı kartınızda bloke edildi; ürünler kargoya verilirken çekilecek.',
  preauthNote:
    'Tutar şimdi kartınızda bloke edilir, ürünler kargoya verilirken çekilir. Tek çekim; banka kartlarıyla (debit) kullanılamayabilir.',
  paymentFailed: 'Ödeme tamamlanamadı.',
  paymentReview: 'Ödemeniz ödeme kuruluşu tarafından inceleniyor. Sonuç sipariş sayfanızda görünecek.',
  paymentPendingLong:
    'Ödeme sonucu henüz gelmedi. Birkaç dakika sonra sipariş sayfanızdan kontrol edebilirsiniz.',
  paymentExpired: 'Ödeme süresi doldu; sipariş iptal edildi.',
  orderNotFound:
    'Sipariş bulunamadı. Bağlantıyı e-postanızdaki gibi eksiksiz açın veya hesabınıza giriş yapın.',
  keepOrderLink: 'Bu sayfanın bağlantısını saklayın: siparişinizi bu bağlantıyla izleyebilirsiniz.',
  trackOrder: 'Siparişi izle',
  paymentLabel: 'Ödeme',
  shipmentTitle: 'Kargo takibi',
  trackingNumber: 'Takip numarası: {{number}}',
  trackShipment: 'Kargoyu takip et',
  partialShipmentNote:
    'Siparişinizin bir bölümü kargoya verildi. Kalan ürünler ayrı paketle gönderilecek; kargoya verildiğinde e-postayla bildirilir.',
  shipmentItems: 'Paketteki ürünler: {{items}}',
  documentsTitle: 'Onayladığınız metinler',
  sellerInfo: 'Satıcı bilgileri',
  mersis: 'MERSİS: {{no}}',
  kep: 'KEP: {{address}}',
  paymentSecureIyzico: 'Ödemeler iyzico güvencesiyle alınmaktadır',
  etbis: "ETBİS'e kayıtlıdır (doğrulamak için tıklayın)",
  etbisQr: 'ETBİS kayıt karekodu',
  consent: {
    title: 'Çerez tercihleri',
    lead: 'Sitenin çalışması için gerekli çerezleri her zaman kullanırız. İzin verirseniz ziyaretinizi ölçmek (analitik) ve ilginize uygun reklam göstermek (pazarlama) için ek çerezler kullanırız. Seçiminizi istediğiniz zaman sayfanın altındaki "Çerez tercihleri" bağlantısından değiştirebilirsiniz.',
    policyLink: 'Çerez Politikası',
    acceptAll: 'Tümünü kabul et',
    rejectAll: 'Reddet',
    preferences: 'Tercihler',
    save: 'Seçimlerimi kaydet',
    close: 'Kapat',
    necessary: 'Zorunlu çerezler',
    necessaryLead: 'Sepet, oturum, güvenlik ve bu tercihin hatırlanması için. Kapatılamaz.',
    alwaysOn: 'Her zaman açık',
    analytics: 'Analitik çerezler',
    analyticsLead: 'Sitenin nasıl kullanıldığını ölçmemize yardım eder.',
    marketing: 'Pazarlama çerezleri',
    marketingLead: 'Reklamların etkisini ölçmek ve ilginize göre reklam göstermek için.',
    providers: 'Hizmetler: {{list}}.',
    providerNames: {
      gtm: 'Google Tag Manager',
      ga4: 'Google Analytics',
      googleAds: 'Google Ads',
      meta: 'Meta (Facebook, Instagram) pikseli',
      tiktok: 'TikTok pikseli',
    },
    transferNote:
      "Bu hizmetlerin sağlayıcıları verileri yurt dışında işleyebilir. Ayrıntılar Çerez Politikası ve Aydınlatma Metni'nde.",
    error: 'Tercihiniz kaydedilemedi. Lütfen tekrar deneyin.',
    footerLink: 'Çerez tercihleri',
  },
  legalFallbackNote: 'Bu metnin bu dildeki sürümü henüz yayımlanmadı; Türkçe sürüm gösteriliyor.',
  legalTemplatedNote:
    'Bu metin örnektir. Sipariş sırasında sipariş bilgilerinizle doldurulmuş hâli gösterilir ve e-postanıza gönderilir.',
  unitPrice: 'Birim fiyat: {{price}} / {{unit}}',
  orderShippingMethod: 'Kargo: {{name}}',
  billingAddress: 'Fatura adresi',
  shippingAddress: 'Teslimat adresi',
  cardSummary: '{{brand}} ···· {{last4}}',
  installmentCount: '{{count}} taksit',
  awaitingTransferNote: 'Siparişiniz havale/EFT ödemesi bekliyor.',
  awaitingCardNote: 'Siparişiniz kart ödemesi bekliyor.',
  checkoutBlocked: 'Şu an sipariş verilemiyor',
  address: {
    fullName: 'Alıcı adı soyadı',
    phone: 'Telefon',
    line1: 'Adres',
    district: 'İlçe',
    city: 'İl',
    postalCode: 'Posta kodu (isteğe bağlı)',
    companyName: 'Firma unvanı',
    taxOffice: 'Vergi dairesi',
    taxNumber: 'Vergi no / TCKN',
    cityAbroad: 'Şehir',
    districtAbroad: 'Eyalet / bölge (isteğe bağlı)',
    abroadNote:
      'Teslimat ülkesi: {{country}}. Başka bir ülkeye gönderim için sayfanın üstünden ülkeyi değiştirin.',
  },
  dealerFields: {
    legalName: 'Firma unvanı',
    tradeName: 'Ticari ad (isteğe bağlı)',
    taxOffice: 'Vergi dairesi',
    taxNumber: 'Vergi no / TCKN',
    phone: 'İşyeri telefonu',
    city: 'İl',
    district: 'İlçe (isteğe bağlı)',
    address: 'Açık adres',
    businessType: 'İşletme türü (ör. veteriner kliniği)',
    note: 'Eklemek istedikleriniz (isteğe bağlı)',
  },
  leafletSections: {
    description: 'Ürün hakkında',
    specs: 'Teknik özellikler',
    videos: 'Videolar',
    documents: 'Belgeler',
    composition: 'Bileşim',
    usage: 'Kullanım',
    warnings: 'Uyarılar',
  },
  orderStatuses: {
    draft: 'Taslak',
    awaiting_payment: 'Ödeme bekliyor',
    paid: 'Ödendi',
    processing: 'Hazırlanıyor',
    shipped: 'Kargoda',
    delivered: 'Teslim edildi',
    completed: 'Tamamlandı',
    cancelled: 'İptal edildi',
  },
  sorts: {
    relevance: 'En uygun',
    newest: 'En yeni',
    price_asc: 'Fiyat (artan)',
    price_desc: 'Fiyat (azalan)',
    name: 'Ada göre',
  },
  paymentMethods: {
    card: 'Kredi/banka kartı',
    paypal: 'PayPal',
    bank_transfer: 'Havale/EFT',
    cash_on_delivery: 'Kapıda ödeme',
    open_account: 'Açık hesap (cari)',
    manual: 'Havale / nakit (mağazayla anlaşılan)',
    gift_card: 'Hediye kartı',
    store_credit: 'Mağaza kredisi',
    loyalty_points: 'Sadakat puanı',
  },
  paymentMethodHints: {
    card: 'Kart bilgileri ödeme kuruluşunun güvenli sayfasında girilir.',
    paypal: 'PayPal hesabınızla PayPal’ın güvenli sayfasında ödersiniz.',
    bank_transfer: 'Banka bilgileri sipariş sonrası gösterilir.',
    cash_on_delivery: 'Ödemeyi teslimatta kargo görevlisine yaparsınız.',
    open_account: 'Tutar bayi cari hesabınıza işlenir.',
  },
  paymentStatuses: {
    authorized: 'Onaylandı (bloke)',
    pending: 'Bekliyor',
    requires_action: 'İnceleniyor',
    captured: 'Alındı',
    failed: 'Başarısız',
    cancelled: 'İptal edildi',
    expired: 'Süresi doldu',
  },
  shipmentStatuses: {
    created: 'Hazırlanıyor',
    in_transit: 'Yolda',
    out_for_delivery: 'Dağıtımda',
    delivered: 'Teslim edildi',
    returned: 'İade edildi',
    exception: 'Teslimatta sorun',
    cancelled: 'İptal edildi',
  },
  carriers: {
    yurtici: 'Yurtiçi Kargo',
    aras: 'Aras Kargo',
    mng: 'MNG Kargo (DHL eCommerce)',
    ptt: 'PTT Kargo',
    surat: 'Sürat Kargo',
    hepsijet: 'HepsiJET',
    kolaygelsin: 'Kolay Gelsin',
    ups: 'UPS',
    other: 'Kargo',
  },
  paymentLink: {
    title: 'Ödeme',
    paid: 'Bu siparişin ödemesi alındı. Teşekkür ederiz.',
    validUntil: 'Bu ödeme bağlantısı {{date}} tarihine kadar geçerlidir.',
    recipient: 'Alıcı: {{name}} · {{place}}',
    payButton: 'Kartla öde',
  },
  legalKinds: {
    kvkk_notice: 'KVKK Aydınlatma Metni',
    membership_terms: 'Üyelik Sözleşmesi',
    pre_information: 'Ön Bilgilendirme Formu',
    distance_sales: 'Mesafeli Satış Sözleşmesi',
    return_policy: 'İade ve Cayma',
    privacy_policy: 'Gizlilik Politikası',
    cookie_policy: 'Çerez Politikası',
  },
  units: {
    kg: 'kg',
    l: 'L',
    piece: 'adet',
  },
  // F7-19: düzenli gönderim
  addressBook: {
    title: 'Adreslerim',
    lead: 'Ödeme adımında seçebileceğiniz teslimat adresleri. Düzenli gönderim varsayılan teslimat adresini kullanır.',
    empty: 'Kayıtlı adresiniz yok.',
    add: 'Yeni adres ekle',
    save: 'Adresi kaydet',
    saved: 'Adres kaydedildi.',
    cancel: 'Vazgeç',
    default: 'Varsayılan teslimat',
    makeDefault: 'Varsayılan yap',
    defaultSaved: 'Varsayılan teslimat adresi değişti.',
    setDefault: 'Varsayılan teslimat adresim olsun',
    delete: 'Sil',
    deleteFor: '{{name}}, {{city}} adresini sil',
    deleteConfirm:
      'Bu adres silinsin mi? Başlamış düzenli gönderimler adresin kopyasını kullanmaya devam eder.',
    deleted: 'Adres silindi.',
  },
  subscription: {
    title: 'Düzenli gönder',
    discount: 'Düzenli siparişte %{{pct}} indirim',
    terms:
      'İlk siparişiniz hemen açılır ve ödeme sayfasına geçersiniz. Sonraki siparişler seçtiğiniz aralıkla güncel fiyattan açılır; ödeme bağlantısını e-postayla gönderir ve Hesabım’da gösteririz, kartınız saklanmaz. Dilediğiniz zaman atlayabilir, erteleyebilir veya iptal edebilirsiniz.',
    interval: 'Gönderim sıklığı',
    everyWeek: 'Her hafta',
    every: 'Her {{n}} haftada bir',
    start: 'Düzenli gönderimi başlat',
    signIn: 'Düzenli gönderim için giriş yapın',
    addAddress: 'Hesabım’a teslimat adresi ekleyin',
  },
  subscriptions: {
    title: 'Düzenli siparişlerim',
    lead: 'Düzenli gönderimlerinizin sonraki gününü görün; atlayın, erteleyin, duraklatın veya iptal edin. Her siparişi ödeme bağlantısıyla kendiniz onaylayıp ödersiniz.',
    linkLead: 'Sonraki gönderim, atla, ertele, iptal',
    signIn: 'Düzenli siparişlerinizi görmek için giriş yapın.',
    empty: 'Düzenli siparişiniz yok. Ürün sayfasındaki "Düzenli gönder" kutusundan başlatabilirsiniz.',
    statuses: {
      active: 'Etkin',
      paused: 'Duraklatıldı',
      cancelled: 'İptal edildi',
    },
    reasons: {
      customer: 'Sizin isteğinizle',
      unpaid: 'Üst üste iki sipariş ödenmediği için duraklatıldı',
      unavailable: 'Ürün artık düzenli gönderimle satılmıyor',
      panel: 'Mağaza tarafından iptal edildi',
      payment_unavailable: 'Ödeme bağlantısı oluşturulamadı; mağazayla iletişime geçin',
    },
    summary: 'Adet: {{quantity}} · {{interval}}',
    next: 'Sonraki sipariş: {{date}}',
    address: 'Teslimat: {{address}}',
    pending: '{{number}} numaralı sipariş ödeme bekliyor ({{total}}).',
    pay: 'Şimdi öde',
    redirecting: 'Ödeme sayfasına yönlendiriliyorsunuz…',
    saved: 'Gönderim sıklığı güncellendi.',
    skip: 'Sonrakini atla',
    skipped: 'Sonraki sipariş atlandı.',
    postponeDate: 'Yeni tarih',
    postpone: 'Ertele',
    postponed: 'Sonraki sipariş ertelendi.',
    pause: 'Duraklat',
    paused: 'Düzenli gönderim duraklatıldı.',
    resume: 'Sürdür',
    resumed: 'Düzenli gönderim sürdürüldü.',
    cancel: 'İptal et',
    cancelled: 'Düzenli gönderim iptal edildi.',
    cancelConfirm:
      'Düzenli gönderim iptal edilsin mi? Yeni sipariş açılmaz. Ödeme bekleyen sipariş ödenmezse süresi dolunca kendiliğinden iptal edilir.',
  },
} as const;
